import type { ReactNode } from 'react'

/* the auth screens' taller, rounder field. every size carries an sm: twin
 * because tailwind-merge only drops the Input primitive's unprefixed classes,
 * leaving its sm: ones to shrink the field on desktop. */
export const AUTH_INPUT =
  'h-10 rounded-xl px-3 text-base disabled:cursor-not-allowed disabled:bg-cream/60 disabled:text-ink-soft disabled:opacity-100 sm:h-10 sm:px-3 sm:text-base'

/**
 * the shared split-screen auth shell: a left form column and the right navy
 * marketing panel. consumed by every logged-out auth/invite screen (login,
 * signup, verify, finish, invite accept) so the panel lives in one place.
 * the left column only provides vertical centering, children own their own
 * max-width and horizontal alignment.
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className='grid min-h-dvh grid-cols-1 lg:grid-cols-2'>
      <div className='flex flex-col justify-center bg-card px-5 pt-[max(2.5rem,env(safe-area-inset-top))] pb-[max(2.5rem,env(safe-area-inset-bottom))] sm:px-8 sm:py-12 md:px-16 lg:px-20'>
        <div className='flex flex-1 items-center'>{children}</div>
      </div>

      <div className='relative hidden flex-col justify-center overflow-hidden bg-accent p-16 lg:flex'>
        <div className='absolute -top-20 -right-20 size-[400px] rounded-full bg-white/[0.05]' />
        <div className='absolute -bottom-10 -left-10 size-[300px] rounded-full bg-white/[0.05]' />

        <blockquote className='relative z-10 max-w-[400px]'>
          <p className='font-display text-[40px] leading-[1.1] tracking-[-0.5px] text-white'>
            Industrial sourcing,
            <br />
            <em>connected.</em>
          </p>
          <p className='mt-6 text-[15px] leading-[1.7] text-white/60'>
            Verified buyers and suppliers, discovered through company profiles
            and engaged through structured RFIs.
          </p>
        </blockquote>

        <div className='relative z-10 mt-10 flex flex-col gap-3'>
          {[
            'Verified company profiles',
            'Structured RFI workflow',
            'Discover, evaluate, engage'
          ].map(item => (
            <div
              key={item}
              className='flex items-center gap-2.5 text-sm text-white/70'
            >
              <span className='flex size-5 items-center justify-center rounded-full bg-white/10'>
                <CheckIcon />
              </span>
              {item}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

function CheckIcon() {
  return (
    <svg viewBox='0 0 10 8' fill='none' className='size-2.5'>
      <path
        d='M1 4l2.5 2.5L9 1'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
